import { axiosInstanceNoToast } from '../../../fetchConfig/axiosConfig.js';
import { isTownViewDevNoPersist } from '../../../utils/townViewDevMode.js';

/**
 * Town portal: resolve the Aventine negotiator who issued offers for this muni/year/court date (DB `issued_by`).
 * Internal users: returns `context.userId` unchanged.
 * @param {Object} context - muniCode, taxYear, optional courtDate (counterparty link scope; omit for muni-wide links)
 */
export async function negotiatorIdForSettlement(context) {
  if (!context.townView) return context.userId;
  if (isTownViewDevNoPersist(true)) return context.userId;
  const body = {
    MuniCode: context.muniCode,
    TaxYear: context.taxYear,
  };
  if (context.courtDate != null && context.courtDate !== '') {
    body.CourtDate = context.courtDate;
  }
  const { data } = await axiosInstanceNoToast.post('/fetch_offer_sending_user_id', body);
  if (!data?.success || data.issued_by == null || data.issued_by === '') {
    throw new Error(data?.error || 'Offer-issuing user not found for town settlement.');
  }
  return data.issued_by;
}
